import { createReducer, on } from '@ngrx/store';
import {
  setIsLoading,
  setIsMobile,
  setLoadingCanceled,
  setLoadingMessage,
} from './settings.actions';
import { initialSettingsState } from './settings.state';

export const settingsReducer = createReducer(
  initialSettingsState,
  on(setIsMobile, (state, { isMobile }) => ({
    ...state,
    isMobile,
  })),
  on(
    setIsLoading,
    (state, { isLoading, message, cancelable, disableBackdrop, disableAnimation }) => ({
      ...state,
      isLoading,
      loadingMessage: message || '',
      loadingCanceled: false,
      loadingCancelable: cancelable || false,
      disableBackdrop: disableBackdrop || false,
      disableAnimation: disableAnimation || false,
    })
  ),
  on(setLoadingMessage, (state, { message }) => ({
    ...state,
    loadingMessage: message,
  })),
  on(setLoadingCanceled, (state, { canceled }) => ({
    ...state,
    loadingCanceled: canceled,
  }))
);
